export default __webpack_public_path__ + "static/media/Rectangle 999.e12ebc58.png";